import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import React, { Suspense } from 'react';

import Navbar from './componants/Navbar';
import Hero from './componants/Hero';
// import Cards from './componants/Cards';
// import Pricing from './componants/Pricing';

// Lazy loading components
const Contact = React.lazy(() => import('./componants/Contact'));
const Services = React.lazy(() => import('./componants/Services'));
const ServicesDream = React.lazy(() => import('./componants/ServicesDream'));
const ServicesLikelihood = React.lazy(() => import('./componants/ServicesLikelihood'));
const ServicesEffortTime = React.lazy(() => import('./componants/ServicesEffortTime'));
const BlogMenu = React.lazy(() => import('./componants/BlogMenu'));
// const BlogHighPerformanceWebsite = React.lazy(() => import('./componants/blog/BlogHighPerformanceWebsite'));
// const BlogSmallBusinessWebsiteNZ = React.lazy(() => import('./componants/blog/BlogSmallBusinessWebsiteNZ'));
const Cards = React.lazy(() => import('./componants/Cards'));
const Pricing = React.lazy(() => import('./componants/Pricing'));
const Reviews = React.lazy(() => import('./componants/Reviews'));
const CaseStudy = React.lazy(() => import('./componants/CaseStudy'));
const Footer = React.lazy(() => import('./componants/Footer'));
const FAQs = React.lazy(() => import('./componants/FAQs'));
const QuoteSection = React.lazy(() => import('./componants/QuoteSection'));
// const BlogRenderer = React.lazy(() => import('./componants/BlogRenderer'));

const blogContext = require.context("./componants/blog/", false, /\.js$/);


function App() {
  return (
    <div className="App">
      <Router>
        <Suspense fallback={<div></div>}>
          <Navbar />
          <Routes>
            <Route 
              path="/" 
              element={
                <>
                  {/* <Hero />
                  <Reviews />
                  <Cards />
                  <Pricing />
                  <CaseStudy /> */}
                  <Hero />
                  <Suspense fallback={<div>Loading content...</div>}>
                    <QuoteSection/>
                    <FAQs />
                    <Cards />
                    {/* <CaseStudy /> */}
                    <Pricing />
                    {/* <Reviews /> */}
                  </Suspense>
                </>
              } 
            />
            <Route path="/contact" element={<Contact />} /> 
            {/* <Route path="/blog" element={<BlogMenu />} />  */}
            {/* <Route path="/blog-high-performance-website" element={<BlogHighPerformanceWebsite />} /> 
            <Route path="/blog-small-business-website-nz" element={<BlogSmallBusinessWebsiteNZ />} />  */}
            <Route path="/blog" element={<BlogMenu />} /> 
            {/* <Route path="/blog-:slug" element={<BlogRenderer />} />  */}

            <Route path="/services" element={
              <>
                <Services />
                <ServicesDream />
                <ServicesLikelihood />
                <ServicesEffortTime />
              </>
              } /> 

            {blogContext.keys().map((path) => {
              const name = path.replace("./", "").replace(".js", "");
              const BlogComponent = React.lazy(() =>
                import(`./componants/blog/${name}.js`)
              );
              return (
                <Route
                  key={name}
                  path={`/${name}`}
                  element={<BlogComponent />}
                />
              );
            })}
                
              <Route path="*" element={<div>404 — Page Not Found</div>} />
          </Routes>
          <Footer />
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
